// KPI Code to Name mapping for Toyota dealership KPIs
export const KPI_CODE_TO_NAME_MAP: Record<string, string> = {
  // Financial Performance (20 KPIs)
  "FIN_001": "Total Revenue",
  "FIN_002": "New Vehicle Revenue",
  "FIN_003": "Used Vehicle Revenue",
  "FIN_004": "Service Revenue",
  "FIN_005": "Parts Revenue",
  "FIN_006": "F&I Revenue",
  "FIN_007": "Gross Profit",
  "FIN_008": "Net Profit",
  "FIN_009": "Operating Expenses",
  "FIN_010": "Marketing Expenses",
  "FIN_011": "Payroll Expenses",
  "FIN_012": "Facility Expenses",
  "FIN_013": "Inventory Carrying Cost",
  "FIN_014": "Working Capital",
  "FIN_015": "Return on Assets",
  "FIN_016": "Return on Equity",
  "FIN_017": "Debt to Equity Ratio",
  "FIN_018": "Current Ratio",
  "FIN_019": "Cash Flow",
  "FIN_020": "EBITDA",

  // Sales Performance (25 KPIs)
  "SAL_001": "Total Units Sold",
  "SAL_002": "New Vehicle Units Sold",
  "SAL_003": "Used Vehicle Units Sold",
  "SAL_004": "Camry Units Sold",
  "SAL_005": "Corolla Units Sold",
  "SAL_006": "RAV4 Units Sold",
  "SAL_007": "Highlander Units Sold",
  "SAL_008": "Prius Units Sold",
  "SAL_009": "Tacoma Units Sold",
  "SAL_010": "Tundra Units Sold",
  "SAL_011": "4Runner Units Sold",
  "SAL_012": "Sienna Units Sold",
  "SAL_013": "Avalon Units Sold",
  "SAL_014": "Sales Conversion Rate",
  "SAL_015": "Lead Conversion Rate",
  "SAL_016": "Average Sale Price",
  "SAL_017": "Gross Profit Per Unit",
  "SAL_018": "Days to Turn Inventory",
  "SAL_019": "Inventory Turnover Rate",
  "SAL_020": "Sales Per Square Foot",
  "SAL_021": "Market Share",
  "SAL_022": "Closing Rate",
  "SAL_023": "Average Days on Lot",
  "SAL_024": "Floor Traffic Count",
  "SAL_025": "Test Drive Conversion",

  // Customer Service (15 KPIs)
  "SVC_001": "Customer Satisfaction Score",
  "SVC_002": "Service Revenue Per RO",
  "SVC_003": "Labor Hours Sold",
  "SVC_004": "Parts Sales Per RO",
  "SVC_005": "Service Absorption Rate",
  "SVC_006": "Technician Productivity",
  "SVC_007": "Average RO Value",
  "SVC_008": "Service Retention Rate",
  "SVC_009": "First Time Fix Rate",
  "SVC_010": "Service Appointment Show Rate",
  "SVC_011": "Warranty Claim Rate",
  "SVC_012": "Customer Wait Time",
  "SVC_013": "Service Bay Utilization",
  "SVC_014": "Comeback Rate",
  "SVC_015": "Express Service Percentage",

  // Marketing & Lead Generation (10 KPIs)
  "MKT_001": "Total Leads Generated",
  "MKT_002": "Digital Leads",
  "MKT_003": "Referral Leads",
  "MKT_004": "Walk-in Leads",
  "MKT_005": "Cost Per Lead",
  "MKT_006": "Marketing ROI",
  "MKT_007": "Website Conversion Rate",
  "MKT_008": "Social Media Engagement",
  "MKT_009": "Email Open Rate",
  "MKT_010": "Brand Awareness Score",

  // Operations & Efficiency (15 KPIs)
  "OPS_001": "Employee Turnover Rate",
  "OPS_002": "Training Hours Per Employee",
  "OPS_003": "Safety Incidents",
  "OPS_004": "Environmental Compliance Score",
  "OPS_005": "Facility Utilization Rate",
  "OPS_006": "Energy Cost Per Square Foot",
  "OPS_007": "IT System Uptime",
  "OPS_008": "Process Efficiency Score",
  "OPS_009": "Quality Control Score",
  "OPS_010": "Vendor Performance Score",
  "OPS_011": "Inventory Accuracy Rate",
  "OPS_012": "Order Fulfillment Time",
  "OPS_013": "Equipment Downtime",
  "OPS_014": "Preventive Maintenance Compliance",
  "OPS_015": "Document Management Score",

  // Finance & Insurance (F&I) (10 KPIs)
  "FI_001": "F&I Penetration Rate",
  "FI_002": "F&I Profit Per Unit",
  "FI_003": "Extended Warranty Sales",
  "FI_004": "GAP Insurance Sales",
  "FI_005": "Credit Life Insurance Sales",
  "FI_006": "Service Contract Sales",
  "FI_007": "Average Finance Rate",
  "FI_008": "Lease Penetration Rate",
  "FI_009": "F&I Customer Satisfaction",
  "FI_010": "Chargeback Rate",

  // Customer Retention & Loyalty (5 KPIs)
  "CRT_001": "Customer Retention Rate",
  "CRT_002": "Repeat Purchase Rate",
  "CRT_003": "Customer Lifetime Value",
  "CRT_004": "Net Promoter Score",
  "CRT_005": "Customer Complaint Resolution Time"
};

/**
 * Get KPI name from KPI code
 * @param kpiCode - The KPI code (e.g., "SAL_001")
 * @returns The KPI name (e.g., "Total Units Sold") or the original code if not found
 */
export const getKPIName = (kpiCode: string): string => {
  return KPI_CODE_TO_NAME_MAP[kpiCode] || kpiCode;
};

/**
 * Get multiple KPI names from an array of KPI codes
 * @param kpiCodes - Array of KPI codes
 * @returns Array of KPI names
 */
export const getKPINames = (kpiCodes: string[]): string[] => {
  return kpiCodes.map(code => getKPIName(code));
};